import GameManager from "../cvp-webgames-core/GameManager";
import BaseScenario from "../cvp-webgames-core/Scenario/BaseScenario";
import { constants } from "../misc/constants";
import PatientRecordUI from "../components/ui/PatientRecordUI";
import { isFunctionDeclaration, isLabeledStatement, isNonNullExpression } from "typescript";
import { IonVirtualScroll } from "@ionic/react";
import { getSaveData, playSound, setFocus, setUp508 } from "../misc/tools";
import { NONAME } from "dns";
import { isContext } from "vm";
import { TransformUIConfig } from "../components/ui/TransformUI";
import { SbarUIConfig, SbarUIMultipleChoiceConfig } from "../components/ui/SbarUI";
import { time } from "console";
import MedsurgBaseScenarioPart from "./MedsurgBaseScenarioPart";
import { Windows } from "../pages/MainPage";

export enum Window508Type {
    Main,
    Modal,
    PatientRecord,
    Remember,
    TalkActionsUI,
    TransformUI,
    ProviderFeedbackUI,
    BadgingProgressUI,
    SbarUI,
    FeedbackUI,
    FullPageQuiz,
    GeneralAlertUI,
    FailUI,
    ConfirmAlertUI,
}

var headerInstanceID: string;
var footerInstanceID: string;
var currentMainWindow = Window508Type.Main;
var current508Window = Window508Type.Main;
var windows508Layers: any[] = []

const objectWindowIDs = {
    main: {
        objects: [] as string []
        // objects: [
        //      'first-object-main',
        //      'last-object-main',
        // ]
    },
    modal: {
        objects: [
            'first-object-modal',
            'last-object-modal',
        ]
    },
    patientRecord: {
        objects: [
            'first-object-pr',
            'last-object-pr',
        ]
    },
    remember: {
        objects: [
            'first-object-remember',
            'last-object-remember',
        ]
    },
    talkActions: {
        objects: [] as string []
        // objects: [
        //     'first-object-taui',
        //     'last-object-taui',
        // ]
    },
    transformUI: {
        objects: [] as string []
        // objects: [
        //     'first-object-transform',
        //     'last-object-transform',
        // ]
    },
    ProviderFeedbackUI: {
        objects: [
            'first-object-providerFeedback',
            'last-object-providerFeedback',
        ]
    },
    BadgingProgressUI: {
        objects: [
            'first-object-badgingProgress',
            'last-object-badgingProgress',
        ]
    },
    sbaruiUI: {
        objects: [
            'first-object-sbarui',
            'last-object-sbarui',
        ]
    },
    feedbackUI: {
        objects: [
            'first-object-feedbackUi',
            'last-object-feedbackUi',
        ]
    },
    fullPageQuizUI: {
        objects: [
            'first-object-fullPageQuiz',
            'last-object-fullPageQuiz',
        ]
    },
    GeneralAlertUI: {
        objects: [
            'first-object-generalAlert',
            'last-object-generalAlert',
        ]
    },
    FailUI: {
        objects: [
            'first-object-failalert',
            'last-object-failalert',
        ]
    },
    ConfirmAlertUI: {
        objects: [
            'confirm-alert-first-object',
            'confirm-alert-last-object',
        ]
    }
}

const setUpScenario508 = () => {
    windows508Layers[Window508Type.Main] = {
        objects: objectWindowIDs.main.objects
    };

    windows508Layers[Window508Type.Modal] = {
        objects: objectWindowIDs.modal.objects
    };

    windows508Layers[Window508Type.PatientRecord] = {
        objects: objectWindowIDs.patientRecord.objects
    };

    windows508Layers[Window508Type.Remember] = {
        objects: objectWindowIDs.remember.objects
    };

    windows508Layers[Window508Type.TalkActionsUI] = {
        objects: objectWindowIDs.talkActions.objects
    };

    windows508Layers[Window508Type.TransformUI] = {
        objects: objectWindowIDs.transformUI.objects
    };

    windows508Layers[Window508Type.ProviderFeedbackUI] = {
        objects: objectWindowIDs.ProviderFeedbackUI.objects
    };

    windows508Layers[Window508Type.BadgingProgressUI] = {
        objects: objectWindowIDs.BadgingProgressUI.objects
    };

    windows508Layers[Window508Type.SbarUI] = {
        objects: objectWindowIDs.sbaruiUI.objects
    };

    windows508Layers[Window508Type.FeedbackUI] = {
        objects: objectWindowIDs.feedbackUI.objects
    };

    windows508Layers[Window508Type.FullPageQuiz] = {
        objects: objectWindowIDs.fullPageQuizUI.objects
    };

    windows508Layers[Window508Type.GeneralAlertUI] = {
        objects: objectWindowIDs.GeneralAlertUI.objects
    };

    windows508Layers[Window508Type.FailUI] = {
        objects: objectWindowIDs.FailUI.objects
    };

    windows508Layers[Window508Type.ConfirmAlertUI] = {
        objects: objectWindowIDs.ConfirmAlertUI.objects
    };
}

const getCurrent508WindowLayer = () => {
	return windows508Layers[current508Window];
}

const set508Window = (window: Window508Type) => {
    if(window === Window508Type.TalkActionsUI) {
        setFocus(windows508Layers[Window508Type.Main].objects[0]);
    }

    setTimeout(() => {
        current508Window = window;
        setFocus(getCurrent508WindowLayer().objects[0]);
    }, 250);
}

setUpScenario508();
setUp508(() => getCurrent508WindowLayer())

set508Window(Window508Type.Main);

export class MedsurgBaseScenario extends BaseScenario {
    constructor(gameManager: GameManager, scenarioName: string) {
        super(gameManager, scenarioName);
    }

    public visit1 = 'Visit 1';
    public visit2 = 'Visit 2';
    public visit3 = 'Visit 3';
    public visit4 = 'Visit 4';
	public patientObservation = 'Patient Observation';
	public patientAssessment = 'Patient Assessment';
    public medicineAdministered = 'Medicine Administered';
    public catheter = 'Catheter';
    public significantIncidents = 'Significant Incidents';
    public tdCatheter = 'Tunnel Dialysis Catheter';
    public advisePatient = 'Advise Patient';
    public painObservation = 'Pain Observation';
    public cmsAssessment = 'CMS Assessment';
    public respiratoryStatus = 'Respiratory Status';
    public chestTube = 'Chest Tube and System';
    public drainageSystem = 'Drainage System';
    public chestAssessment = 'Chest Tube Assessment';

	public allVisits = [
		this.visit1,
        this.visit2,
        this.visit3,
        this.visit4
	]

	public allHeaders = [
		this.patientObservation,
		this.patientAssessment,
        this.medicineAdministered,
        this.catheter,
        this.significantIncidents,
        this.tdCatheter,
        this.advisePatient,
        this.painObservation,
        this.cmsAssessment,
        this.respiratoryStatus,
        this.chestTube,
        this.drainageSystem,
        this.chestAssessment
	]

    public updateMain508Window(window: Window508Type) {
        currentMainWindow = window;
    }

    public update508Window(window: Window508Type) {
        set508Window(window);
    }

    public getScenarioData(): ScenarioData {
        throw new Error('getScenarioData must be implemented');
    };

    public setScenarioData(data: ScenarioData): void {
        throw new Error('setScenarioData must be implemented');
    };

    public evaluateScoreForSbar(updatedConfig: SbarUIConfig): void {
        var newScore = 0;

        var quizzes: SbarUIMultipleChoiceConfig[] = [updatedConfig.s, updatedConfig.r]
        for (var i = 0; i < quizzes.length; i++) {
            var quiz = quizzes[i]
            var maxCorrectAnswerCount = quiz.options.filter(O => O.isCorrect).length;

            if (typeof quiz.maxPoints !== 'undefined' && maxCorrectAnswerCount > 0) {
                var wrongSelectionCount = quiz.options.filter(t => !t.isCorrect && t.isSelected).length;
                var correctSelectionCount = quiz.options.filter(t => t.isCorrect && t.isSelected).length;
                var scorePerQuestion = quiz.maxPoints / maxCorrectAnswerCount;
                var selectionCount = quiz.options.filter(t => t.isSelected).length;
                var exceededSelectionCount = selectionCount - maxCorrectAnswerCount;

                //subtract incorrect
                if (exceededSelectionCount > 0) {
                    newScore -= (scorePerQuestion * exceededSelectionCount);
                }
                //newScore -= (scorePerQuestion * wrongSelectionCount);

                //add correct
                newScore += (scorePerQuestion * correctSelectionCount);
            }

        }

        this.updateScore(newScore);
    }

    public evaluateScoreForPainScale(updatedConfig: TransformUIConfig): void {
        var newScore = 0;

        if (updatedConfig.painScaleCorrect === updatedConfig.painAssessment) {
            newScore = updatedConfig.painScaleMaxPoints;
        }

        this.updateScore(newScore);
    }

    public evaluateScoreForTalk(updatedConfig: TransformUIConfig): void {
        var totalScore = 0;

        for (var i = 0; i < updatedConfig.quiz.length; i++) {
            var newScore = 0;
            var quiz = updatedConfig.quiz[i]
            var maxCorrectAnswerCount = quiz.talks.filter(t => t.isCorrect).length;

            if (typeof quiz.maxPoints !== 'undefined' && maxCorrectAnswerCount > 0) {
                var wrongSelectionCount = quiz.talks.filter(t => !t.isCorrect && t.isSelected).length;
                var correctSelectionCount = quiz.talks.filter(t => t.isCorrect && t.isSelected).length;
                var scorePerQuestion = quiz.maxPoints / maxCorrectAnswerCount;
                var selectionCount = quiz.talks.filter(t => t.isSelected).length;
                var exceededSelectionCount = selectionCount - maxCorrectAnswerCount;

                //subtract incorrect
                if (exceededSelectionCount > 0) {
                    newScore -= (scorePerQuestion * exceededSelectionCount);
                }
                //newScore -= (scorePerQuestion * wrongSelectionCount);

                //add correct
                newScore += (scorePerQuestion * correctSelectionCount);
            }
            if (newScore > 0) {
                totalScore += newScore;
            }

        }

        this.updateScore(totalScore);
    }

    public getScenarioDataEntryItems(id: string): ScenarioItemEntry[] {
        var data = this.getScenarioData();

        for (var i = 0; i < data.entries.length; i++) {
            if (data.entries[i].id === id) {
                return data.entries[i].items;
            }
        }

        return null;
    };

    public updateScenarioDataEntry(id: string, data: ScenarioItemEntryContainer): void {
        var scenarioData = this.getScenarioData();

        for (var i = 0; i < scenarioData.entries.length; i++) {
            if (scenarioData.entries[i].id === id) {
                scenarioData.entries[i] = data;
                return;
            }
        }
    };

    public appendToScenarioDataEntry(id: string, data: any, allVisits?: string[], allheaders?: string[], visit?: string, header?: string): void {
        var scenarioData = this.getScenarioData();
        for (var i = 0; i < scenarioData.entries.length; i++) {
            if (scenarioData.entries[i].id === id) {
                var entry = scenarioData.entries[i];
                var visitIndx = undefined;
                var headerIndx = undefined;
                if (visit || header) {
                    for (var p = 0; p < entry.items.length; p++) {
                        var entryItem = entry.items[p] as any
                        if (header && entryItem.title === header) {
                            headerIndx = p;
                        } else if (visit && entryItem.visit === visit) {
                            visitIndx = p;
                        }
                    }
                }

                var updated = false;

                if (typeof headerIndx !== 'undefined') {
                    for (var p = headerIndx + 1; p < entry.items.length; p++) {
                        var entryItem = entry.items[p] as any
                        if (entryItem.title && allheaders.indexOf(entryItem.title) !== -1) {
                            headerIndx = p;
                            updated = true;
                            break;
                        }
                    }

                    if (updated) {
                        scenarioData.entries[i].items.splice(headerIndx, 0, data);
                    } else {
                        scenarioData.entries[i].items.push(data);
                    }

                }
                else if (typeof visitIndx !== 'undefined') {
                    for (var p = visitIndx + 1; p < entry.items.length; p++) {
                        var entryItem = entry.items[p] as any
                        if (entryItem.visit && allVisits.indexOf(entryItem.visit) !== -1) {
                            visitIndx = p;
                            updated = true;
                            break;
                        }
                    }

                    if (updated) {
                        scenarioData.entries[i].items.splice(visitIndx, 0, data);
                    } else {
                        scenarioData.entries[i].items.push(data);
                    }
                } else {
                    scenarioData.entries[i].items.push(data);
                }

                // if(typeof insertAfter === 'undefined') {
                //     scenarioData.entries[i].items.push(data);
                //     // return scenarioData.entries[i].items.length - 1;
                // } else {
                //     scenarioData.entries[i].items.splice(insertAfter + 1, 0, data);
                //     // return insertAfter+1;
                // }
            }
        }




    };

    private providerInstanceID: string;
    private modalPopID: string;
    private newScore: number = 0;
    private oldScore: number = 0;
    private savedScore: number = 0;

    public audioHall: string = './assets/audio/Hallway_Ambient.mp3';
    public audioRoom: string = './assets/audio/Patient_Room_Ambient.mp3';
    public ambientLoop: boolean = false;
    public static loopedAudio: string;
    public static audioPlaying: boolean;

    public playAmbientLoop = (audio: string) => {        
        if(MedsurgBaseScenario.loopedAudio != audio) {
            MedsurgBaseScenario.loopedAudio = audio;
            this.stopAmbientLoop();
            this.ambientLoop = false;            
        }
        if(!this.ambientLoop && !MedsurgBaseScenario.audioPlaying) {
            MedsurgBaseScenario.audioPlaying = true;
            this.playSound(MedsurgBaseScenario.loopedAudio,() => {
            MedsurgBaseScenario.audioPlaying = false;
            this.playAmbientLoop(MedsurgBaseScenario.loopedAudio);
            },false,false,true)
        }
    }

    public stopAmbientLoop = () => {
        this.ambientLoop = true;
        this.stopSound(this.audioHall);
        this.stopSound(this.audioRoom);
    }

    

    public avatarIndx = 0;

    public init(onDone: () => void): void {
        if (typeof this.gameManager.customData.saveData.avatarIndx !== 'undefined') {
            this.avatarIndx = this.gameManager.customData.saveData.avatarIndx;
        }
        (window as any).onCaptionsChanged = () => {
            if(headerInstanceID) {
                this.gameManager.UiManager.updateUIInstance(headerInstanceID);
            }
        }
        onDone();
    }

    public unlockNextLevel() {
        this.gameManager.customData.saveData.scenarios[1].isUnlocked = true;
        this.gameManager.customData.saveGame(this.gameManager);
    }

    private clearProgressExceptBadges() {
        this.gameManager.customData.saveData.scenarios[this.currentLevel].lastPartId = null;
        var scenarioData = this.getScenarioData();
        this.setScenarioData(scenarioData);
        this.gameManager.customData.saveData.scenarios[this.currentLevel].scenarioData = scenarioData;
        this.gameManager.customData.saveGame(this.gameManager);
    }

    public shouldLoadScenario(): boolean {
        (window as any)['scenario'] = this;
        var currentScenario = this.gameManager.customData.saveData.scenarios[this.currentLevel];
        var lastPartId = currentScenario.lastPartId;
        var context = this;
        if (lastPartId) {
            var parts = this.getParts();

            const onYes = () => {
                context.destroyAllUIInstances();
                context.setScenarioData(currentScenario.scenarioData);
                context.newScore = currentScenario.score;
                context.savedScore = currentScenario.score;
                context.oldScore = context.savedScore;
                const load = (index: number) => {
                    (parts[index] as MedsurgBaseScenarioPart).PreloadUis(true);
                    
                    if (parts[index].partId === lastPartId) {
                        //load the next part
                        context.loadPart(parts[index + 1].partId);
                        return;
                    }
                    // for(var indx = 0; indx < parts.length - 1; indx++) {
                    //     if(parts[indx].partId === lastPartId) {
                    //         //load the next part
                    //         context.loadPart(parts[indx + 1].partId);
                    //         break;
                    //     } else {
                    //         (parts[indx] as MedsurgBaseScenarioPart).PreloadUis(true);
                    //     }
                    // }
                    setTimeout(() => {
                        load(index + 1);
                    }, 0);
                }
                setTimeout(() => {
                    load(0);
                }, 0);
            }
            if (localStorage.getItem('ignoreResumePopup') === 'true') {
                localStorage.removeItem('ignoreResumePopup');
                onYes();
            } else {
                this.gameManager.UiManager.createUIInstance(constants.uiNames.ConfirmAlertUI, {
                    onYes: () => onYes(),
                    onNo: () => {
                        context.destroyAllUIInstances();
                        context.clearProgressExceptBadges();
                        window.location.reload();
                    },
                    text: 'Would you like to resume the level or start over from the beginning?',
                    yesBttnText: 'Resume',
                    noBttnText: 'Start Over'
                });
            }

            return true;
        }

        return false;
    }

    public resetScenario(): boolean {
        var currentScenario = this.gameManager.customData.saveData.scenarios[this.currentLevel];
        var lastPartId = currentScenario.lastPartId;
        var context = this;
        if (lastPartId) {
            var parts = this.getParts();
            context.destroyAllUIInstances();
            context.setScenarioData(currentScenario.scenarioData);
            context.newScore = currentScenario.score;
            context.savedScore = currentScenario.score;
            for (var indx = 0; indx < parts.length - 1; indx++) {
                if (parts[indx].partId === lastPartId) {
                    //load the next part
                    context.loadPart(parts[indx].partId);
                    context.loadPart(parts[indx + 1].partId);
                    break;
                } else {
                    (parts[indx] as MedsurgBaseScenarioPart).PreloadUis(true);
                }
            }

            return true;
        }

        return false;
    }

    public get currentLevel(): number {
        throw new Error('currentLevel must be implemented');
    }

    public displayHeader() {
        var context = this;
        var lastWindow = Window508Type.Main;

        if(headerInstanceID) {
            this.gameManager.UiManager.destroyUIInstanceById(headerInstanceID, true);
        }

        headerInstanceID = this.gameManager.UiManager.createUIInstance(constants.uiNames.HeaderUI, {
            score: this.newScore,
            display: 'none',
            onMainMenuClicked: () => {
                context.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
                lastWindow = current508Window;
                context.update508Window(Window508Type.ConfirmAlertUI);
            },
            onMainMenuPromptDismissed: () => {
                context.update508Window(lastWindow);
                lastWindow = Window508Type.Main;
                //context.gameManager.UiManager.showAllUis(null);
            }
        });
    }

    public updateScore(addedScore: number) {
        if (addedScore < 0) {
            addedScore = 0;
        }

        addedScore = Math.round(addedScore);

        if (addedScore === 0) {
            return;
        }

        playSound('./assets/audio/Gain_Points');

        var context = this;
        if (headerInstanceID) {
            this.newScore = this.oldScore + addedScore;
            context.gameManager.UiManager.updateUIInstance(headerInstanceID, {
                score: this.newScore.toString(),
                scorePop: addedScore.toString(),
                display: 'inline-block',
            });
            setTimeout(() => {
                this.gameManager.UiManager.updateUIInstance(headerInstanceID, {
                    display: 'none'
                });
            }, 1500);

            this.oldScore = this.newScore;
        } else { context.displayHeader() }
    }

    public saveScore() {
        var context = this;
        this.savedScore = this.newScore;
        this.gameManager.customData.saveData.scenarios[context.currentLevel].score = this.savedScore
        this.gameManager.customData.saveData.scenarios[context.currentLevel].scenarioData = this.getScenarioData();
        this.gameManager.customData.saveGame(this.gameManager);
    }

    public resetScore() {
        var context = this;
        if (headerInstanceID) {
            context.gameManager.UiManager.updateUIInstance(headerInstanceID, {
                score: this.savedScore,
            });
            this.oldScore = this.savedScore;
        } else { context.displayHeader() }
    }

    public displayDebrief(levelTotal: number, onRetry: () => void, onDone: () => void) {
        var context = this;
        setTimeout(() => {
            context.update508Window(Window508Type.BadgingProgressUI);
        }, 1000);
        this.gameManager.UiManager.createUIInstance(constants.uiNames.BadgingProgressUI, {
            playerScore: (this.newScore - this.savedScore),
            maxScore: levelTotal,
            starsAwarded: ((this.newScore - this.savedScore) / levelTotal),
            onRetryClicked: () => {
                context.destroyAllUIInstances();
                onRetry();
            },
            onContinueClicked: () => {
                context.destroyAllUIInstances();
                onDone();
            }
        });
    }

    public displayFinalDebrief(level1: boolean, levelTotal: number, onRetry: () => void) {
        var context = this;
        var level = level1 ? 0 : 1;

        var savedData = getSaveData();

        for(var badgeIndx = 0; badgeIndx < savedData.scenarios[level].badges.length; badgeIndx++) {
            var badge = savedData.scenarios[level].badges[badgeIndx];
            badge.isUnlocked = true;
        }

        this.gameManager.customData.saveData = savedData;
        this.gameManager.customData.saveGame(this.gameManager);

        setTimeout(() => {
            context.update508Window(Window508Type.BadgingProgressUI);
        }, 1000);

        this.gameManager.UiManager.createUIInstance(constants.uiNames.BadgingProgressUI, {
            playerScore: this.newScore,
            maxScore: levelTotal,
            starsAwarded: (this.newScore / levelTotal),
            finalDebrief: true,
            level1: level1,
            onRetryClicked: () => {
                context.destroyAllUIInstances();
                onRetry();
            },
            onContinueClicked: () => {
                context.destroyAllUIInstances();
                context.gameManager.customData.updateWindow(Windows.MainMenu)
            },
            onLevel2Clicked: () => {
                context.destroyAllUIInstances();
                context.gameManager.customData.updateWindow(Windows.Level2)
            }
        });
    }

    public displayFooter(PrID?: () => string, TalkID?: () => string, ActionID?: () => string, talksNum?: string, actionsNum?: string, talksZero?: boolean, actionsZero?: boolean) {
        var context = this;
        if(footerInstanceID) {
            this.gameManager.UiManager.destroyUIInstanceById(footerInstanceID);
        }
        footerInstanceID = this.gameManager.UiManager.createUIInstance(constants.uiNames.FooterUI, {
            onPrClicked: () => {
                context.hideAllUIsWithTransitions(() => {
                    setTimeout(() => {
                        context.update508Window(Window508Type.PatientRecord)
                    }, 1000);
                    context.showUIInstanceWithTransitions(PrID())
                });
            },
            onTalksClicked: () => {
                context.hideAllUIsWithTransitions(() => {
                    setTimeout(() => {
                        context.update508Window(Window508Type.TalkActionsUI)
                    }, 1000);
                    context.showUIInstanceWithTransitions(TalkID())
                });
            },
            onActionsClicked: () => {
                context.hideAllUIsWithTransitions(() => {
                    setTimeout(() => {
                        context.update508Window(Window508Type.TalkActionsUI)
                    }, 1000);
                    context.showUIInstanceWithTransitions(ActionID())
                });
            },
            talksNum: talksNum,
            actionsNum: actionsNum,
            talksZero: talksZero,
            actionsZero: actionsZero,
        });

        context.gameManager.UiManager.updateUIInstance(headerInstanceID, {
            ignoreFinalName: true
        });
    }

    public updateFooter(newTalksNum?: string, newActionsNum?: string, newTalksZero?: boolean, newActionsZero?: boolean) {
        var context = this;
        context.gameManager.UiManager.showUiInstance(footerInstanceID);
        this.gameManager.UiManager.updateUIInstance(footerInstanceID, {
            talksNum: newTalksNum,
            actionsNum: newActionsNum,
            talksZero: newTalksZero,
            actionsZero: newActionsZero,
        });
    }

    public hideFooter() {
        var context = this;
        context.gameManager.UiManager.updateUIInstance(footerInstanceID, {
            talksNum: 0,
            actionsNum: 0,
            talksZero: true,
            actionsZero: true,
        });
        context.gameManager.UiManager.hideUiInstance(footerInstanceID);
    }

    public destroyFooter() {
        var context = this;
        context.gameManager.UiManager.destroyUIInstanceById(footerInstanceID);
    }

    public showRemediation(text: string, img: string, onContinueClicked: () => void, smallerTitle?: boolean, audio?: string, loopAudio?: boolean, isAudioRelative?: boolean) {
        const context = this;
        var canPlay = true;
        if (audio) {
            const playAudio = () => {
                context.playSound(audio + '.mp3', () => {
                    if (loopAudio && canPlay) {
                        playAudio();
                    }
                }, false, false, !isAudioRelative);
            };

            playAudio();
        }

        this.update508Window(Window508Type.FailUI);

        this.gameManager.UiManager.createUIInstance(constants.uiNames.FailUI, {
            text: text,
            img: img,
            smallerTitle: smallerTitle,
            onContinueClicked: () => {
                canPlay = false;
                context.gameManager.SoundManager.stopAllSounds();
                this.update508Window(Window508Type.Main);
                onContinueClicked();
            }
        })
    }

    public displayModalPop(title: string, text: string, onContinueClicked: () => void, audio?: string, loopAudio?: boolean, isAudioRelative?: boolean) {
        const context = this;
        var canPlay = true;
        if (audio) {
            const playAudio = () => {
                context.playSound(audio + '.ogg', () => {
                    if (loopAudio && canPlay) {
                        playAudio();
                    }
                }, false, false, !isAudioRelative);
            };

            playAudio();
        }

        setTimeout(() => {
            context.update508Window(Window508Type.Modal);
        }, 1200);
        this.modalPopID = this.gameManager.UiManager.createUIInstance(constants.uiNames.ModalPopUI, {
            title: title,
            text: text,
            onContinueClicked: () => {
                this.update508Window(currentMainWindow);
                canPlay = false;
                context.gameManager.SoundManager.stopAllSounds();
                onContinueClicked();
            }
        })
    }

    public endModalPop() {
        var context = this;
        document.getElementById(this.modalPopID).remove();
    }

    public displayRemember(onContinueClicked: () => void) {
        const context = this;
        this.gameManager.UiManager.createUIInstance(constants.uiNames.RememberUI, {
            onContinueClicked: () => {
                onContinueClicked();
            }
        })
    }

    public destroyAllUIInstances() {
        this.gameManager.UiManager.destroyAllInstances([constants.uiTags.Hud, constants.uiTags.PrUi, constants.uiTags.TaUi]);
    }

    public hideAllUIsWithTransitions(onDone?: () => void) {
        const context = this;
        const tagExceptions = [constants.uiTags.Hud];

        var waitTime = 0;

        for (var uiIndx = 0; uiIndx < context.gameManager.UiManager.uis.length; uiIndx++) {
            var ui = context.gameManager.UiManager.uis[uiIndx];

            if (ui.tag && tagExceptions && tagExceptions.indexOf(ui.tag) !== -1) {
                continue;
            }

            for (var instanceIndx = 0; instanceIndx < ui.instances.length; instanceIndx++) {
                const parameters = ui.instances[instanceIndx].parameters;

                if (parameters.updateVisibility && parameters.isVisible) {
                    waitTime = 500;
                    parameters.updateVisibility(false, () => { })
                }
            }
        }

        setTimeout(() => {
            context.gameManager.UiManager.hideAllUis(tagExceptions);
            if (onDone) {
                onDone();
            }
        }, waitTime);
    }

    public hideUIInstanceWithTransitions(id: string, onDone?: () => void) {
        const context = this;

        var instance = context.gameManager.UiManager.getInstanceById(id);

        if (!instance) {
            return;
        }

        setTimeout(() => {
            context.gameManager.UiManager.hideUiInstance(id);
            if (onDone) {
                onDone();
            }
        }, 500);

        // setTimeout(() => {
        if (instance.parameters.updateVisibility) {
            instance.parameters.updateVisibility(false, () => { })
        }
        // }, 100);
    }

    public showUIInstanceWithTransitions(id: string, onDone?: () => void) {
        const context = this;
        context.gameManager.UiManager.showUiInstance(id);

        var instance = context.gameManager.UiManager.getInstanceById(id);

        if (!instance) {
            return;
        }

        setTimeout(() => {
            if (onDone) {
                onDone();
            }
        }, 500);

        // setTimeout(() => {
        if (instance.parameters.updateVisibility) {
            instance.parameters.updateVisibility(true, () => { })
        }
        // }, 100);
    }

    public exitGame() {

    }

    public nextLevel() {

    }

    public displayBeginScenarioUI(image: string, audio: string, levelIndx: number, onDone: () => void) {
        const context = this;
        var instance = '';
        var audioFinished = true;
        this.playSound(audio, () => {
            context.gameManager.SoundManager.stopAllSounds();
            audioFinished = true;
        });
        instance = context.gameManager.UiManager.createUIInstance(constants.uiNames.BeginScenarioUI, {
            image: image,
            levelIndx: levelIndx,
            onClick: () => {
                if(audioFinished) {
                    onDone();
                }
            },
        });
    }

    public showFeedback(feedback: string, onDone: () => void) {
        this.gameManager.UiManager.hideAllUis([]);
        var context = this;
        context.update508Window(Window508Type.GeneralAlertUI);

        playSound('./assets/audio/Wrong_Answer');

        const instanceId = this.gameManager.UiManager.createUIInstance(constants.uiNames.FeedbackUI, {
            text: feedback,
            onContinueClicked: () => {
                context.update508Window(Window508Type.Main)
                context.gameManager.UiManager.destroyUIInstanceById(instanceId);
                onDone();
                //context.gameManager.UiManager.showAllUis([]);
            }
        })
    }

    public showProvider(feedback: string, onDone: () => void, image?: string,) {
        var context = this;
        this.update508Window(Window508Type.ProviderFeedbackUI);
        this.providerInstanceID = context.gameManager.UiManager.createUIInstance(constants.uiNames.ProviderFeedbackUI, {
            text: feedback,
            img: image,
            fade: 'in'
        });

        setTimeout(() => {
            this.gameManager.UiManager.updateUIInstance(this.providerInstanceID, {
                fade: 'out'
            });
        }, 5000);

        setTimeout(() => {
            this.gameManager.UiManager.destroyUIInstanceById(this.providerInstanceID);
            onDone();
        }, 6000);
    }
}


export interface ScenarioData {
    entries: ScenarioItemEntryContainer[];
};

export interface ScenarioItemEntryContainer {
    id: string;
    items: ScenarioItemEntry[];
}

export interface ScenarioItemEntry {
    id: string;
}

export interface Vital {
    title?: string;
    description?: string;
    list?: string;
}

export interface Notes {
    title?: string;
    description?: string;
    list?: string;
}